export default __webpack_public_path__ + "static/media/DingLing.5a3b13f6.mp3";